module.exports = __webpack_public_path__ + "static/img/logo.6b8b3cb7.png";